import { useEffect, useState } from "react"
import { Wrapper, Header, TextsSection, HeadingColor, FrameWrapper, Frame, Topic, FrameHeading, StoryWrapper, Text, Correct, TranslateLink } from "./StoriesStyle"
import { StoriesData } from "./StoriesData"
import Topics from "../04_topics/Topics"
import { TopicData } from "../04_topics/TopicsData"
import useInstantScroll from "../../../hooks/useInstalntScroll"
import ToTheTop from "../../../components/04_common/02_tothetop/ToTheTop"
import { useSelector } from "react-redux"
import { speaking } from "../../../i18n/09_speaking"

const Stories = () => {
  const lang = useSelector(state => state.lang.lang)
  const t = speaking[lang]

  const [isGuest, setIsGuest] = useState(false)

  const [storyData, setStoryData] = useState(
    StoriesData)

  const { lessons } = useSelector(state => state.studentLessons)
  const { jumpToHash } = useInstantScroll();

  const role = useSelector((s) => s.auth?.user?.role); // ✅ add
  const isPrivileged = role === "TEACHER" || role === "ADMIN"; // ✅ add

  const isLessonUnlocked = (lessonNumber) => {
    // ✅ TEACHER/ADMIN: show everything
    if (isPrivileged) return true;

    if (!lessons || lessons.length === 0) {
      return lessonNumber === 0
    }
    const lesson = lessons.find((l) => l.order === lessonNumber)
    return !!lesson?.isUnlocked
  }

  const clickLesson = (lessonNumber) => {
    if (!isLessonUnlocked(lessonNumber)) return
    jumpToHash(`#lesson-${lessonNumber}`)
  }

  const clickTranslate = (e) => {
    const mainIndex = Number(e.target.id)
    e.preventDefault();
    let prevStoryData = [...storyData]
    prevStoryData[mainIndex].display = prevStoryData[mainIndex].display === "none" ? "block" : "none"
    setStoryData(prevStoryData)
  }


  // const handleTopicClick = (index) => {

  //   jumpToHash(`#lesson-${index + 1}`)
  // }

  useEffect(() => {
    setIsGuest(!lessons || lessons.length === 0);
  }, [lessons]);

  return (
    <Wrapper>
      <Header>
        {t.storiesHeader}
      </Header>
      <Topics
        isGuest={isGuest}
        isLessonUnlocked={isLessonUnlocked}
        clickLesson={clickLesson}
      />

      {storyData.map((mainValue, mainIndex) => {

        const lessonNumber = mainIndex + 1
        if (!isLessonUnlocked(lessonNumber)) {
          return null
        }

        return (
          <TextsSection
            key={mainIndex}
            id={`lesson-${lessonNumber}`}
          >


            <Frame>
              <HeadingColor>
                Lesson {lessonNumber}
                <Topic>
                  {TopicData[mainIndex].topic}
                </Topic>
              </HeadingColor>

              <Text>{mainValue.story}</Text>
              <TranslateLink
                id={mainIndex}
                onClick={clickTranslate}
              >Переклад</TranslateLink>
              <Correct style={{ display: mainValue.display }}>
                {mainValue.translation}
              </Correct>
            </Frame>

          </TextsSection>
        )
      })}
      <ToTheTop />
    </Wrapper>
  )
}

export default Stories